var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-4 mb-3"},[_c('div',{staticClass:"text-dark-75 text-center"},[_c('span',{staticClass:"text-muted font-weight-bold"},[_vm._v("© "+_vm._s(new Date().getFullYear())+" ")]),_vm._v(" Kema. All rights reserved.")])])}
var staticRenderFns = []

export { render, staticRenderFns }